<script>
import SparkLine from '../svelte/SparkLine/public/es-bundle';

export default {
  name: 'SparkLine',
  props: {
    points: {
      type: Array,
      required: true,
    },
    tooltipTemplate: {
      type: String,
      default: 'Average fixed price $[y]', // The '[y]' and '[x]' tokens will be replaced with the data value
    },
  },
  watch: {
    points: function(points) {
      this.sparkImpl.set({ points });
    },
  },
  mounted() {
    this.sparkImpl = new SparkLine({
      target: this.$refs.widget,
      data: {
        points: this.points || [],
        tooltipTemplate: this.tooltipTemplate,
      },
    });
  },
};
</script>

<template>
  <div ref="widget"></div>
</template>
